import { observer } from 'mobx-react';
import { ExperienceResource } from '../../../Common/Experience/Types';
import ExperienceProductDetails from './ExperienceProductDetails';
import ProgramCompetencies from './ProgramCompetencies';

interface Props {
  experienceResource: ExperienceResource;
}

function ExperienceCompetenciesItems({ experienceResource }: Props) {
  switch (experienceResource.payload.offeringType) {
    case 'aep':
    case 'epc':
    case 'msuite':
      return <ProgramCompetencies experienceResource={experienceResource} />;
    case 'coaching':
    case 'group-coaching':
    case 'program-sequence':
      return <ExperienceProductDetails experienceResource={experienceResource} />;
  }
}

export default observer(ExperienceCompetenciesItems);
